export const normalizeAccountName = (accountName: string): string =>
  accountName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
